<template>
  <div id="menu-public-content">



      <div class="blur-effect" @click="closeRicerca"></div>

      <div class="search-window">
        <img src="/storage/media/icons/svg/icona-lente.svg" alt="search">
        <input class="campo-ricerca" :placeholder="$trans('public.search.cod-art')" type="text" v-model="searchTxt" @keyup="startSearch">
        <div class="risultati" v-if="searchResult">
          <div class="risultato-riga" v-for="art in searchResult">
            <a :href="art.link_card">
              <div class="thumb-art">
                <image-elm :elm="art"/>
              </div>
              <div class="desc-art">
                <p>
<!--                  <cod-elm :elm="art"/>-->
                  {{art.cod_art}}
                </p>
                <p class="categoria">{{ art.category.descrizione }}</p>
              </div>
              <div class="arrow-art">
                <img
                    :src="url('/media/icons/svg/arrow-right_white.svg')"
                    alt="arrow"/>
              </div>
            </a>
          </div>
        </div>
      </div>



  </div>
</template>

<script>
export default {
  name: "ricerca",
  data() {
    return {
      searchTxt: null,
      searchResult: null,
    }
  },
  mounted() {
  },
  methods: {

    closeRicerca(){
      this.$emit('close')
    },
    startSearch(){
      this.searchResult = null
      if (this.searchTxt.length >= 2){
        axios({
          method: 'get',
          url: window.location.origin + '/search',
          params: {
            searchTxt: this.searchTxt
          }
        }).then(res => {
          console.log(res.data)
          this.searchResult = res.data
        }).catch(err => {
          console.log(err.response.data)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
 #menu-public-content {
   height: 100vh;
   width: 100vw;
   position: relative;
   .blur-effect {
     backdrop-filter: blur(15px);
     width: 100%;
     height: 100%;
     position: fixed;
     z-index: 10;
   }
   .search-window {
     position: absolute;
     width: 35%;
     height: 50px;
     left: 50%;
     top: 40px;
     transform: translate(-50%);
     background-color: #3B3B43;
     z-index: 11;
     border-bottom: 1px solid #8d8d89;
     display: flex;
     padding: 10px;
     align-items: center;
     img {
       height: 20px;
     }
     @media (max-width: 576px) {
       width: 100%;
     }
     .campo-ricerca {
       margin-left: 30px;
       width: 100%;
       height: 90%;
       border: 0;
       color: var(--text-white);
       font-size: 1em;
       padding: 1px;
     }
     .risultati {
       position: absolute;
       top: 50px;
       left: 0;
       background-color: #3B3B43;
       padding-top: 20px;
       width: 100%;
       height: calc(100vh - 250px);
       overflow-y: scroll;
       @media (max-width: 576px){
         height: calc(100vh - 90px);
       }
       .risultato-riga a {

         width: 100%;
         display: flex;

         align-items: center;
         padding: 5px 20px;
         border-bottom: 1px solid #8d8d89;
         .thumb-art {
           img {
             height: 100px;
           }
         }
         .desc-art {
           margin-left: 50px;
         }
         .arrow-art {
           margin-left: auto;
           align-self: center;
           img {
             height: 13px;
           }
         }
         .categoria {
           color: var(--greenb2b);
           text-transform: lowercase;
           &:first-letter {
             text-transform: uppercase;
           }
         }
       }
     }
   }
 }
</style>
